module.exports = __webpack_public_path__ + "img/kam.353d98d4.jpg";